import {JSrcFields} from "lib/wsp/src";

export interface JGitSrcFields extends JSrcFields {
	gitSt?: number
}

export const enum EGitState {

	//Valeurs NON combinables

	/** Hors GIT workspace */
	none = -1,
	/** File in synch with the index and the tree repo */
	insynch= 0,


	//Valeurs combinables
	/** File in conflict */
	conflicting= 1,
	/** File not ignored, and not in the index */
	untracked= 2,
	/** File ignored */
	ignored= 4,
	/** Added to the index, but not in the tree repo */
	added= 8,
	/** File changed from tree to index */
	changed= 16,
	/** File modified on working filesystem relative to the index */
	modified= 32,
	/** File removed from index, but not in tree repo */
	removed= 64,
	/** File in index, but not in working filesystem */
	missing= 128
}

export type EGitSimpleState = "none" | "insynch" | "untracked" | "ignored" | "adding" | "updating" | "deleting" | "conflict"

export namespace WSP_GIT {

	export function getSimpleState(gitSt: number | undefined): EGitSimpleState {
		if (gitSt === undefined || gitSt === EGitState.none) return "none";
		if (gitSt === EGitState.insynch) return "insynch";
		if (match(gitSt, EGitState.conflicting)) return "conflict";
		if (gitSt === EGitState.untracked) return "untracked";
		if (gitSt === EGitState.ignored) return "ignored";
		if (match(gitSt, EGitState.added)) return "adding";
		if (match(gitSt, EGitState.missing) || match(gitSt, EGitState.removed)) return "deleting";
		if (match(gitSt, EGitState.modified) || match(gitSt, EGitState.changed)) return "updating";
		throw Error("Unkonwn simple GIT status : " + gitSt);
	}

	export function match(st: number, flag: number) {return (st & flag) === flag}

	export function getGitStateLabel(st: EGitSimpleState): string {return gitSimpleStates[st] || ""}

	const gitSimpleStates = {
		"none": "Aucun entrepôt Git détecté",
		"insynch": "", //fichier ou dossier, msg pas simple.
		"untracked": "Fichier non suivi par Git",
		"ignored": "Fichier explicitement ignoré par Git",
		"adding": "Fichier en cours d'ajout dans Git",
		"updating": "Fichier en cours de modification Git",
		"deleting": "Fichier en cours de suppression Git",
		"conflict": "Fichier en conflit Git"
	}
}